import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faStar as faStarRegular } from '@fortawesome/free-regular-svg-icons';
import { faStar } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent {
  @Input() title: string;
  @Input() icon: string;
  @Input() favorite: boolean = false;
  // Emits an event to notify the parent when value changes
  @Output() favoriteEvent = new EventEmitter<boolean>();

  /**
   * Emits an event when favorite value changes
   * @returns None
   */
  setFavorite() {
    this.favoriteEvent.emit(!this.favorite);
  }

  /**
   * Sets a different icon depending on the favorite value
   * @returns None
   */
  setIcon() {
    return this.favorite ? faStar : faStarRegular;
  }
}